import $ from "jquery";
import Swiper, { Navigation, Pagination, EffectFade } from "swiper";

$(function () {
  Swiper.use([Navigation, Pagination, EffectFade]);

  const oppsSwiper = new Swiper(".js-opps-swiper", {
    modules: [Navigation, Pagination],
    slidesPerView: 2,
    spaceBetween: 50,
    loop: false,
    breakpoints: {
      0: {
        slidesPerView: 1,
        spaceBetween: 40,
      },
      976: {
        spaceBetween: 50,
      },
    },
    navigation: {
      nextEl: ".js-opps-swiper .swiper-button-next",
      prevEl: ".js-opps-swiper .swiper-button-prev",
    },
    pagination: {
      el: ".js-opps-swiper .swiper-pagination",
      type: "bullets",
      clickable: true,
    },
  });

  const teamSwiper = new Swiper('.js-team-swiper', {
    modules: [Navigation, Pagination],
    slidesPerView: 3,
    spaceBetween: 100,
    navigation: {
      nextEl: ".js-team-swiper .swiper-button-next",
      prevEl: ".js-team-swiper .swiper-button-prev",
    },
    pagination: {
      el: ".js-team-swiper .swiper-pagination",
      type: "bullets",
      clickable: true,
    },
    breakpoints: {
      0: {
        spaceBetween: 30,
        slidesPerView: 1,
      },
      768: {
        slidesPerView: 2,
      },
      976: {
        spaceBetween: 50,
      },
      1440: {
        spaceBetween: 100,
      }
    }
  });

  const testimonialsSwiper = new Swiper('.js-testimonials-swiper', {
    modules: [Navigation],
    slidesPerView: 1,
    spaceBetween: 20,
    allowTouchMove: true,
    on: {
      slideChange: function (swiper) {
        const slide = swiper.slides[swiper.activeIndex];
        $('.js-testimonials-name').text(slide.dataset.name);
        $('.js-testimonials-title').text(slide.dataset.title);
      }
    }
  });

  $('.js-testimonials-left').on('click', function () {
    testimonialsSwiper.slidePrev(300);
  });

  $('.js-testimonials-right').on('click', function () {
    testimonialsSwiper.slideNext(300);
  }); 

});
